export const coachOffersKeys = {
  all: ["coachOffers"] as const,
  list: () => [...coachOffersKeys.all, "list"] as const,
  detail: (id: string) => [...coachOffersKeys.all, "detail", id] as const,
}
